import React from 'react';
import {useIntl} from '@sail/intl';
import {
  Section,
  ColumnLayout,
  Copy,
  CtaButton,
  Buildings,
  HelmIcon,
  QuestionMarks,
} from '@sail/helm';
import {useLinkResolver} from 'mkt-ssr/lib/routing/LinkResolver';
import * as messages from 'mkt-ssr/components/sail/pages/StartupPartners/FooterCTASection.messages';

export const FooterCTASection = () => {
  const intl = useIntl();
  const {createRoute} = useLinkResolver();

  return (
    <Section theme="white">
      <ColumnLayout rowGap="xlarge" columns="2,1,1">
        <Copy
          variant="footer"
          title={intl.formatMessage(messages.sectionTitle)}
          body={intl.formatMessage(messages.sectionBody)}
          cta={
            <CtaButton href={createRoute('https://stripe.com/atlas')}>
              {intl.formatMessage(messages.sectionCta)}
            </CtaButton>
          }
        />

        <Copy
          variant="detail"
          icon={<HelmIcon icon={QuestionMarks} />}
          title={intl.formatMessage(messages.entityTypesTitle)}
          body={intl.formatMessage(messages.entityTypesBody)}
          cta={
            <CtaButton
              href={createRoute(
                'https://stripe.com/guides/atlas/llc-vs-c-corp',
              )}
              type="link"
            >
              {intl.formatMessage(messages.entityTypesCta)}
            </CtaButton>
          }
        />
        <Copy
          variant="detail"
          icon={<HelmIcon icon={Buildings} />}
          title={intl.formatMessage(messages.incorporationGuideTitle)}
          body={intl.formatMessage(messages.incorporationGuideBody)}
          cta={
            <CtaButton
              href={createRoute(
                'https://stripe.com/guides/atlas/incorporation',
              )}
              type="link"
            >
              {intl.formatMessage(messages.incorporationGuideCta)}
            </CtaButton>
          }
        />
      </ColumnLayout>
    </Section>
  );
};
